import DayJSAdapter from '@date-io/dayjs';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import 'vuetify/styles';

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    ssr: true,
    date: {
      adapter: DayJSAdapter,
    },

    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            // Base
            background: '#FFFFFF',
            surface: '#FFFFFF',
            secondary: '#44445F',

            // Brand
            primary: '#1777FF',
            'primary-darken-1': '#145EC7',
            'primary-lighten-1': '#5A93FF',
            'primary-lighten-2': '#D2E5FF',
            'primary-lighten-3': '#F3F8FF',

            // Text
            'text-primary': '#050529',
            'text-secondary': '#44445F',
            'text-tertiary': '#828294',
            'text-disabled': '#B4B4BF',

            // Surfaces
            'surface-background-2': '#F7F7F9',
            'surface-background-3': '#E6E6EA',
            'surface-fields-tags': '#F2F2F4',
            'surface-inverted': '#050529',

            // Borders
            'border-default': '#E6E6EA',
            'border-disabled': '#F2F2F4',
            'border-secondary': '#44445F',

            // Complementary
            complementary: '#5393CE',
            'complementary-1': '#87B3DD',
            'complementary-2': '#E5F3FE',
            'complementary-3': '#F6FAFD',

            // Semantic
            success: '#458C03',
            'success-light': '#ECF3E6',
            'success-dark': '#182E1E',
            warning: '#FFA722',
            'warning-light': '#FFF6E9',
            'warning-dark': '#503627',
            error: '#F10021',
            'error-light': '#FEE5E9',
            'error-dark': '#4C0427',
            info: '#0093C9',
            'info-light': '#E5F7FE',
            'info-dark': '#043966',

            // Disabled
            disabled: '#B4B4BF',
          },
        },
      },
    },
    defaults: {
      global: {
        ripple: false,
      },
      VBtn: {
        flat: true,
      },
      VTextField: {
        class: 'bordered-input',
      },
    },
  });

  nuxtApp.vueApp.use(vuetify);
});
